module.exports = __webpack_public_path__ + "img/kommune-1805.a17ecc92.svg";